import(/* webpackMode: "eager", webpackExports: ["AboutUsPage"] */ "/app/slw/pages/about-us/about-us.page.tsx");
